import { Link } from "react-router-dom";
import { Leaf, Truck, ShieldCheck, Cpu } from "lucide-react";

export default function About() {
    return (
        <div data-testid="about-page">
            <section className="container-edge py-16 md:py-24">
                <div className="label-mono text-magenta">Sobre nós</div>
                <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter mt-3 max-w-3xl">
                    Tecnologia <span className="text-magenta">acessível</span>, sustentável
                    e <em className="not-italic">sem complicações.</em>
                </h1>
                <p className="mt-6 max-w-2xl text-ink/70 text-lg leading-relaxed">
                    A SOSTONERS nasceu para tornar consumíveis informáticos e equipamentos mais
                    económicos, fiáveis e amigos do ambiente. Combinamos preços competitivos,
                    qualidade premium e atendimento técnico humano.
                </p>
            </section>

            <section className="bg-ink text-white">
                <div className="container-edge grid md:grid-cols-4 gap-0 border-y-2 border-magenta">
                    {[
                        { icon: Leaf, t: "Sustentável", s: "Recondicionados certificados, redução de resíduos." },
                        { icon: Truck, t: "Rapidez", s: "Despacho 24h, transportadoras CTT e DPD." },
                        { icon: ShieldCheck, t: "Garantia", s: "Até 24 meses em todos os produtos." },
                        { icon: Cpu, t: "B2B / B2C", s: "Empresas, escolas, hotéis e particulares." },
                    ].map(({ icon: Icon, t, s }, i) => (
                        <div
                            key={t}
                            className={`p-8 ${i < 3 ? "md:border-r-2 border-magenta" : ""}`}
                        >
                            <Icon className="text-magenta" size={28} />
                            <div className="font-display font-bold text-xl mt-4">{t}</div>
                            <div className="text-sm text-white/70 mt-2">{s}</div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="container-edge py-16 text-center">
                <Link to="/loja" className="btn-primary">Explorar Catálogo</Link>
            </section>
        </div>
    );
}
